import { render, staticRenderFns } from "./HospitalDoctorPreview.vue?vue&type=template&id=0e1c93aa"
import script from "./HospitalDoctorPreview.vue?vue&type=script&lang=js"
export * from "./HospitalDoctorPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports